<template>
    <div class="num_box">
        <div class="top_banner">
            <div class="header lucky_header">
                <van-nav-bar title="幸运号码" left-arrow>
                    <div slot="left" >
                        <i @click="goBack" class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
                        <!-- <span class="city_btn" @click="cityShow">{{citySelect.city}} <span>&#9660;</span></span> -->
                    </div>
                    <div slot="right" class="contact">
                        <span class="contact_bg"></span>
                        <span class="contact_text" @click="contactServer">联系客服</span>
                    </div>
                </van-nav-bar>
            </div>
        </div>
        <!-- <div class="user_info" v-if="userId">
            <div class="info_box">
                <span class="info_name1">{{this.utils.geTel(userName)}},你好</span> -->
                <!-- <span class="info_name2">选号账户：<span>{{Number(balanceNum)?Number(balanceNum):'0'}}</span><span v-show="balanceNum.indexOf('.')==-1">.00</span><span>元</span></span> -->
                <!-- <span class="info_name2">选号账户:&nbsp;
                    <router-link to="/luckyNumDetail" class="balance_box">
                        <span class="balance_num1">{{balanceNum | filterNum(1)}}</span>
                        <span class="balance_num2" v-if="balanceNum">{{balanceNum | filterNum(2)}}</span>
                        <span class="bottom_line"></span>
                    </router-link>

                    <span class="yuan">元</span>
                </span>
            </div>
            <ul class="info_btn">
                <router-link tag="li" to="/luckyPay/1">充值</router-link>
                <router-link tag="li" to="/luckyNumber">查看已有号码</router-link>
            </ul>
        </div> -->

        <!-- <div class="user_info" v-else>
            <div class="info_box1">
                <span>您尚未登录</span>
                <span>登录后可查看已有幸运号</span>
            </div>
            <ul class="info_btn1">
                <router-link tag="li" to="/loginOrReg/1">注册</router-link>
                <router-link tag="li" to="/loginOrReg/0">登录</router-link>
            </ul>
        </div> -->
        <!-- <router-link tag="li" to="/luckyPay/1"><div class="activity"></div></router-link> -->
        <!-- <div v-if="activityImg !=[]" class="activityImgBox" @click="activityLink">
            <img :src="activityImg.logoFile" alt="" width="100%" height="100%">
        </div> -->
        <!-- <div class="ps_info_box">
            <p class="ps_info">非售彩！幸运号码为推荐号，非实际出票，不能兑奖。</p>
        </div> -->
        <!-- <p class="ps_info">AI选号：运用大数据技术，通过大量运算精推方案，更科学、更稳定！ </p> -->
		<div class="line"></div>
		<div class="part">
			<div><img src="../../assets/img/home/yghm.png" alt="" @click="$router.push({path:'/luckyNumber',query:{}})">已购号码</div>
			<div><img src="../../assets/img/home/zhcz.png" alt="" @click="$router.push({path:'/luckyPay/1',query:{}})">账户充值</div>
			<div><img src="../../assets/img/home/jjmx.png" alt="" @click="$router.push({path:'/index',query:{}})">个人中心</div>
			<!-- <div><img src="../../assets/img/home/jjmx.png" alt="" @click="$router.push({path:'/luckyNumDetail',query:{}})">奖金明细</div> -->
		</div>
		<div class="line"></div>
        <div class="top_type">
            <div class="type_title" >
                <div class="type_select">选择号码类型： </div>
                <router-link :to="this.userId ? '/LuckyNumber':'/loginOrReg'" style="display:none">
                    <div class="check_num">查看已有的幸运号 >  </div>
                </router-link>
            </div>
            <div :class="isKlb ?  'wrapper wrapper1' : 'wrapper'">
                <!--
                        "FC_SSQ":null,
                        "TC_DLT":null,
                        "FC_3D":null,
                        "TC_PL3":null,
                        "FC_K3":null,
                        "TC_11X5":null
                     -->
                <!-- -----快乐8 FC_KL8 -->
                <div class="item_box" v-if="lotteryList.FC_KL8">
                  <div class="item_title">
                    <span>{{lotteryList.FC_KL8.lotteryName | typeName}}</span>
                    <p>第{{lotteryList.FC_KL8.issue}}期号码</p>
                    <p class="item_title_text" @click="toHisAnalysis1(lotteryList.FC_KL8.lotteryName)">历史战绩></p>
                  </div>
                  <ul class="type_list">
                    <li
                      v-for="(items, index) in lotteryList.FC_KL8.items"
                      :key="index"
                      :class="[ index > 2 ? 'mar_line1': '' , items.selectStatus ? index > 2 ? 'select1' : 'select' : '', 'list_item', (items.status=='1') && (index > 2) ? 'noSelect_item1' : '']"
                      @click="selectItem(items.itemId,0,'1',items.status,items.errorMsg)"
                      >
                      <div
                        :class="['type_name type_name1', items.selectStatus ? 'select_item' : '', items.status=='1' ? 'noSelect_item' : '']">
                        {{items.itemName}}  <span :class="items.status=='1'? 'sj no_sj' :'sj'">{{ items.itemName.length<3 ? '售价':'售' }}:{{items.price}}元</span></div>
                      <div :class="['money_num1',items.selectStatus?'select_item':'',items.status=='1'?'noSelect_item':'']">
                        {{ tipsList[index] }}</div>
                    </li>
                  </ul>
                </div>
                <!-- -----双色球 -->
                <div class="item_box" v-if="lotteryList.FC_SSQ">

                    <div class="item_title">
                        <span>{{lotteryList.FC_SSQ.lotteryName | typeName}}</span>
                        <p>第{{lotteryList.FC_SSQ.issue}}期号码</p>
                        <p class="item_title_text" @click="toHisAnalysis(lotteryList.FC_SSQ.lotteryName)">历史战绩></p>
                    </div>
                    <ul class="type_list">
                        <li
                            v-for="(items, index) in lotteryList.FC_SSQ.items"
                            :key="index+'d'"
                            :class="[items.selectStatus?'AISelect4':'','list_AIitem4',items.status=='1'?'AI_gray4':'']"
                            @click="selectItem(items.itemId,0,'1',items.status,items.errorMsg)"
                            v-show="items.itemType=='18'"
                            >
                            <div class="type_name"
                                >
                                <span :style="items.status=='1'?'color:#B0B0B0':''">{{items.itemName}}</span>
                                <span class="money_num dylz" :style="items.status=='1'?'color:#B0B0B0':''">售价：{{items.price}}元</span>
                            </div>
                            <div class="money_num" :style="items.status=='1'?'color:#B0B0B0':''">方案内容：大底方案20+5；精推方案11+3</div>
                        </li>
                        <li
                            v-for="(items, index) in lotteryList.FC_SSQ.items"
                            :key="index"
                            :class="[index=='1'||index=='4'?'mar_line':'',items.selectStatus?'select':'','list_item']"
                            :style="items.status=='1'?'background:#F8F8F8':''"
                            @click="selectItem(items.itemId,0,'1',items.status,items.errorMsg)"
                            v-show="items.itemType!='18'"
                            >
                            <div
                                :class="['type_name',items.selectStatus?'select_item':'',items.status=='1'?'noSelect_item':'']">{{items.itemName}}</div>
                            <!-- <div class="lucky_num">{{item.luckyNum}}</div> -->
                            <!-- <div class="lucky_num">&nbsp;</div> -->
                            <div :class="['money_num',items.selectStatus?'select_item':'',items.status=='1'?'noSelect_item':'']">售价：{{items.price}}元</div>
                        </li>
                    </ul>
                </div>
                <!-- -----大乐透 -->
                <div class="item_box" v-if="lotteryList.TC_DLT">

                    <div class="item_title">
                        <span>{{lotteryList.TC_DLT.lotteryName | typeName}}</span>
                        <p>第{{lotteryList.TC_DLT.issue}}期号码</p>
                        <p class="item_title_text" @click="toHisAnalysis(lotteryList.TC_DLT.lotteryName)">历史战绩></p>
                    </div>
                    <ul class="type_list">
                        <li
                            v-for="(items, index) in lotteryList.TC_DLT.items"
                            :key="index+'d'"
                            :class="[items.selectStatus?'AISelect3':'','list_AIitem3',items.status=='1'?'AI_gray3':'']"
                            @click="selectItem(items.itemId,0,'1',items.status,items.errorMsg)"
                            v-show="items.itemType=='19'"
                            >
                            <div class="type_name"
                                >
                                <span :style="items.status=='1'?'color:#B0B0B0':''">{{items.itemName}}</span>
                                <span class="money_num dylz" :style="items.status=='1'?'color:#B0B0B0':''">售价：{{items.price}}元</span>
                            </div>
                            <div class="money_num" :style="items.status=='1'?'color:#B0B0B0':''">方案内容：大底方案20+5；精推方案11+3</div>
                        </li>

                        <li
                            v-for="(items, index) in lotteryList.TC_DLT.items"
                            :key="index"
                            :style="items.status=='1'?'background:#F8F8F8':''"
                            :class="[index=='1'||index=='4'?'mar_line':'',items.selectStatus?'select':'','list_item']"
                            @click="selectItem(items.itemId,0,'1',items.status,items.errorMsg)"
                            v-show="items.itemType!='19'"
                            >
                            <div :class="['type_name',items.selectStatus?'select_item':'',items.status=='1'?'noSelect_item':'']"
                                >{{items.itemName}}</div>
                            <!-- <div class="lucky_num">{{item.luckyNum}}</div> -->
                            <!-- <div class="lucky_num">&nbsp;</div> -->
                            <div :class="['money_num',items.selectStatus?'select_item':'',items.status=='1'?'noSelect_item':'']">售价：{{items.price}}元</div>
                        </li>
                    </ul>
                </div>

                 <!-- -----排列3 -->
                <div class="item_box" v-if="lotteryList.TC_PL3">
                    <div class="item_title">
                        <span>{{lotteryList.TC_PL3.lotteryName | typeName}}</span>
                        <p>第{{lotteryList.TC_PL3.issue}}期号码</p>
                    </div>
                    <!-- <p class="ps_info">AI选号：运用大数据技术，通过大量运算精推方案，更科学、更稳定！ </p> -->

                    <ul class="type_list">
                        <li
                            v-for="(items, index) in lotteryList.TC_PL3.items"
                            :key="index+'z'"
                            :class="[items.selectStatus?'AISelect':'','list_AIitem',items.status=='1'?'AI_gray':'']"
                            @click="selectItem(items.itemId,0,'1',items.status,items.errorMsg)"
                            v-show="items.selectType=='1'"
                            >
                            <div class="type_name"
                                >
                                <span :class="'text_color'+items.newSelectStatus" :style="items.status=='1'?'color:#B0B0B0':''">{{items.itemName.slice(0,2)}}</span>
                                <span :style="items.status=='1'?'color:#B0B0B0':''">{{items.itemName.slice(2,items.itemName.length)}}</span>
                            </div>
                            <div class="money_num" :style="items.status=='1'?'color:#B0B0B0':''">售价：{{items.price}}元</div>
                        </li>
                        <li
                            v-for="(items, index) in lotteryList.TC_PL3.items"
                            :key="index"
                            :class="[index=='1'||index=='4'?'mar_line':'',items.selectStatus?'select':'','list_item']"
                            @click="selectItem(items.itemId,0,'1',items.status,items.errorMsg)"
                            :style="items.status=='1'?'background:#F8F8F8':''"
                            v-show="items.selectType=='0'"
                            >
                            <!-- <div class="new_luckynum" v-show="items.itemName=='精选7码复式'"></div> -->
                            <div
                                :class="['type_name',items.selectStatus?'select_item':'',items.status=='1'?'noSelect_item':'']"
                                >{{items.itemName}}</div>
                            <!-- <div class="lucky_num">{{item.luckyNum}}</div> -->
                            <!-- <div class="lucky_num">&nbsp;</div> -->
                            <div :class="['money_num',items.selectStatus?'select_item':'',items.status=='1'?'noSelect_item':'']">售价：{{items.price}}元</div>
                        </li>
                    </ul>
                </div>

                <!-- -----3D -->
                <div class="item_box" v-if="lotteryList.FC_3D">

                    <div class="item_title">
                        <span>{{lotteryList.FC_3D.lotteryName | typeName}}</span>
                        <p>第{{lotteryList.FC_3D.issue}}期号码</p>
                        <!-- <p class="item_title_p" @click="toAnalysis">试机号战绩></p> -->
                    </div>
                    <ul class="type_list">
                        <li
                            v-for="(items, index) in lotteryList.FC_3D.items"
                            :key="index"
                            :style="items.status=='1'?'background:#F8F8F8':''"
                            :class="[index=='1'||index=='4'?'mar_line':'',items.selectStatus?'select':'','list_item']"
                            @click="selectItem(items.itemId,0,'1',items.status,items.errorMsg)"
                            >
                            <div v-if="items.itemType == 16" class="list_item_img">30天</div>
                            <!-- <div class="new_luckynum" v-show="items.itemName=='精选7码复式'"></div> -->
                            <div :class="['type_name',items.selectStatus?'select_item':'',items.status=='1'?'noSelect_item':'']">{{items.itemName}}</div>
                            <!-- <div class="lucky_num">{{item.luckyNum}}</div> -->
                            <!-- <div class="lucky_num">&nbsp;</div> -->
                            <div :class="['money_num',items.selectStatus?'select_item':'',items.status=='1'?'noSelect_item':'']">售价：{{items.price}}元</div>
                        </li>
                    </ul>
                </div>
                <!-- <p class="ps_info2" v-show="heightList.length!==0">高频彩种获取时请关注截止剩余时间，尽快完成支付！</p> -->
            </div>

        </div>
         <!-- 复制地址下载 -->
        <van-popup v-model="showPayType" class='payWraper'>
            <div class="pay_box">
                <div class="close_btn" @click="closePayBox"></div>

                <div class="pay_title">请使用微信支付</div>
                <!-- <div
                    :class="money &&payType==='1'?'ali_pay_box itempay_box select_pay':'ali_pay_box itempay_box'"
                    @click="userSelectPay(1)"
                    >
                    <div class="pay_logo"></div>
                    <div class="pay_text">
                        <p>支付宝支付</p>
                        <p class="type_info">仅支持60-3000元，请在7:00-24:00使用。</p>
                    </div>
                    <div class="sub_script"></div>
                </div> -->
                <div
                    :class="payType==='4'?'wx_pay_box itempay_box select_pay':'wx_pay_box itempay_box'"
                    @click="payType='4'"
                    >
                    <div class="pay_logo"></div>
                    <div class="pay_text">
                        <p>微信支付</p>
                        <p class="type_info">仅支持10-3000元</p>
                    </div>
                    <div class="sub_script"></div>
                </div>

                <p v-show="!parPrompt" class="affirm_info">确认支付即表示同意活动规则，支付后将无法退回。</p>
                <div v-show="!parPrompt" class="affirm_pay">
                    <div class="pay_btn" @click="confirmPayment">确认支付</div>
                </div>
            </div>

        </van-popup>
         <!-- 复制地址下载 -->
        <van-popup v-model="loadingStatus" class='loadingStatus' style="background:none;">
            <van-loading color="#fafafa" />
        </van-popup>
        <div class="bot_con">
          <div class="pay_top" v-if="isKlb">
            <div class="pay_tips" v-if="istips">提示：仅快8可包月购买，其他彩种均按照单期购买</div>
            <div class="gmfs">购买方式：
              <span :class="choosetype=='dq' ? 'select_type' : ''" @click="byEvent('dq')">
                <img v-if="choosetype=='by'" src="../../assets/img/home/choose.png" alt="">
                <img v-if="choosetype=='dq'" src="../../assets/img/home/choosed.png" alt="">单期
              </span>
              <span :class="choosetype=='by' ? 'select_type' : ''" @click="byEvent('by')">
                <img v-if="choosetype=='dq'" src="../../assets/img/home/choose.png" alt="">
                <img v-if="choosetype=='by'" src="../../assets/img/home/choosed.png" alt="">包月 <img class="lz" src="../../assets/img/home/lz.png" alt="">
              </span>
              <span @click="contactHelp"><img src="../../assets/img/home/help.png" alt=""></span>
            </div>
          </div>
          <div class="pay_wrapper">
            <div class="total_amount">
              <p>合计金额：¥<span>{{ choosetype=='dq' ? money.toFixed(2) : money.toFixed(2)*1 + byMoney*1 - djbyMoney*1 }}</span></p>
              <!-- <p>高频请关注剩余时间，尽快支付!</p> -->
            </div>
            <div class="now_get" @click="paystatusfn">去支付</div>
          </div>
        </div>
        <!-- 城市弹层 -->
        <!-- <div v-show="cityStatus" class="city_wraper" @click="closeCityStatus" @touchmove.prevent>
            <p></p>
            <ul class="city_box">
                <li
                    :class="item.status?'select_city':''"
                    v-for="(item,index) of cityList"
                    :key="index"
                    @click.stop="selectCity(item.coding)"
                    >{{item.city}}</li>
            </ul>
        </div> -->


        <!-- 支付提示 -->
        <van-popup v-model="isNoPay" class='payWraper'>
            <div class="close_btn" @click="isNoPay = !isNoPay"></div>
            <div class="payPrompt">
                <p>支付功能暂时无法使用，请下载“幸运选号”获取幸运号码。下载地址：http://xhxz.xyxh888.cn，使用浏览器粘贴地址。</p>
                <p>客服微信：17710502071、17710505950</p>
                <p @click="copyPrompt">复制地址</p>
            </div>
        </van-popup>
        <!-- 联系客服 -->
        <div class="bg_box" v-if="contactKf" @touchmove.prevent>
            <div :class="promptStatus=='0'?'call_box':'call_box1'">
                <div class="call_cont" v-show="promptStatus=='0'">
                    <div class="call_text">&nbsp;</div>

                    <div class="close_btn" @click="closeCallBox"></div>
                    <!-- <div class="describe">付款成功后，将在10分钟内生成幸运号码，并赠送幸运币。</div> -->
                    <div class="call_text">&nbsp;</div>
                    <div class="call_text">如遇问题，请联系客服： </div>
                    <div class="c_item wx_box">
                        <img class='wx_logo' src="../../assets/img/luckyNum/icn_weixin@2x.png">
                        <div @click="wxCopy"> 17710505950（点击复制）</div>
                    </div>
                    <div class="c_item">
                        <img class='phone_logo' src="../../assets/img/luckyNum/ico_phone@2x.png">
                        <div><a  href="tel:400-616-0930">400-616-0930（点击拨打）</a></div>
                    </div>
                </div>


                <div class="call_cont" v-show="promptStatus=='2'">
                    <div class="close_btn" @click="closeCallBox"></div>
                    <div class="call_text">&nbsp;</div>

                    <div class="describe1" style="line-height:30px">11选5幸运选号方案支持3种玩法，包括任选二、任选三4码、任选七8码。幸运选号为多期方案，请在建议的期数范围内进行参考。</div>
                </div>

                <div class="call_cont" v-show="promptStatus=='1'">
                    <div class="close_btn" @click="closeCallBox"></div>
                    <div class="call_text">&nbsp;</div>
                    <div class="describe1" style="line-height:30px">快3幸运选号方案支持2种玩法，包括三不同和二同号。幸运选号为多期方案，请在建议的期数范围内进行参考。</div>

                </div>
				<div class="call_cont" v-show="promptStatus=='3'">
                    <div class="close_btn" @click="closeCallBox"></div>
                    <div class="call_text call_text1">&nbsp;提示</div>
                    <div class="describe1 describe2" style="line-height:30px">快8 包月为30期</div>
					<div class="konw_btn" @click="closeCallBox">知道了</div>
                </div>
            </div>
        </div>
        <!-- 联系客服end -->
        <!-- 微信支付二维码 -->
        <div class="qrCode_con" v-show="isWxTips" @touchmove.prevent>
            <p @click="payLayer"></p>
            <img :src="qrCodeSrc">
        </div>

         <!-- 支付后弹层 -->
        <div class="first_tc_box" v-show="closeingStatus" @touchmove.prevent>
            <div class="f_layer">
                <p class="f_layer_text1 pay_before1">已经完成支付，请点击【支付完成】。 还未安装支付宝客户端，请点击【重新支付】，选择其他支付方式。 </p>
                <p class="f_layer_text2 pay_before2"> <router-link to="/payHelp">支付宝充值遇到问题？点我>></router-link></p>
                <div class="f_btn">
                    <div class="item_btn cancel" @click="closePayLayer">重新支付</div>
                    <div class="item_btn confirm" @click="payStatusFn">支付完成</div>
                </div>
            </div>
        </div>
          <!-- 在微信中使用支付宝支付 -->
        <div class="zfb_tips" v-show="wxZfbTips" @click="wxZfbTips = false"></div>
         <!-- 查询支付状态-->
        <div class="first_tc_box" v-show="searchPayStatus">
            <div class="f_layer">
                <p class="pay_money pay_money_y">&nbsp;</p>
                <p class="pay_money pay_money_y">&nbsp;</p>
                <!-- <p class="cheap_num cheapOrderAmount giftAmount1">支付成功<br>请返回点击"查看已有的幸运号"</p> -->
                <p class="cheap_num cheapOrderAmount giftAmount1">幸运号码已生成</p>
                <p class="pay_money pay_money_y">&nbsp;</p>

                <div class="f_btn">
                    <div class="item_btn" style="background:#fff" @click="goBackFn('0')">返回</div>
                    <div class="item_btn confirm" @click="goBackFn('1')">查看号码</div>
                </div>
            </div>
        </div>

        <!-- 选中支付类型 -->
        <div class="first_tc_box" v-show="selectPayStatus">
            <div class="f_layer">
                <div class="close_btn" @click="selectPayStatus=!selectPayStatus"></div>
                <p class="pay_money pay_money_y">&nbsp;</p>
                <p class="pay_money pay_money_y">&nbsp;</p>
                <!-- <p class="cheap_num cheapOrderAmount giftAmount1">支付成功<br>请返回点击"查看已有的幸运号"</p> -->
                <p class="cheap_num cheapOrderAmount giftAmount1">您的选号账户余额不足，请充值！</p>
                <p class="pay_money pay_money_y">&nbsp;</p>

                <div class="f_btn">
                    <div class="item_btn" style="background:#fff" @click="selectPayStatus = false,showPayType = true" v-if="money>9">直接购买</div>
                    <router-link to="/luckyPay" class="item_btn confirm" tag="div">立即充值</router-link>
                </div>
            </div>
        </div>

        <!-- 余额支付成功提示 -->
        <div class="first_tc_box" v-show="balancePayStatus">
            <div class="f_layer">
                <p class="pay_money pay_money_y">&nbsp;</p>
                <p class="pay_money pay_money_y">&nbsp;</p>
                <p class="cheap_num cheapOrderAmount giftAmount1">选号账户扣款成功！</p>
                <p class="pay_money pay_money_y">选号账户余额：{{balanceNum}}元</p>
                <!-- <p class="cheap_num cheapOrderAmount giftAmount1" style="margin-top:10px;font-size:12px;color:red;">3D试机号分析会在每天18:20左右更新，请注意查看。</p> -->

                <div class="f_btn">
                    <div class="item_btn" style="background:#fff" @click="balancePayFn">返回</div>
                    <div class="item_btn confirm" @click="goBackFn('1')">查看幸运号码</div>
                </div>
            </div>
        </div>
        <!-- 跨期提示 -->

        <div class="first_tc_box" v-show="kqStatus">
            <div class="f_layer">
                <p class="pay_money pay_money_y">&nbsp;</p>
                <p class="pay_money pay_money_y">&nbsp;</p>
                <!-- <p class="cheap_num cheapOrderAmount giftAmount1">支付成功<br>请返回点击"查看已有的幸运号"</p> -->
                <p class="cheap_num cheapOrderAmount giftAmount1">当前方案已截止，请重新获取方案！</p>
                <p class="pay_money pay_money_y">&nbsp;</p>

                <div class="f_btn">
                    <div class="item_btn confirm" @click="kqFn()">确定</div>
                </div>
            </div>
        </div>
        <div class="list_loading" v-show="listLoading">
            <van-loading color="#fafafa" />
        </div>
    </div>
</template>
<script>
import itemList from "./list.js"
import cityList from "./city.js"
export default {
    name: 'LuckyNumPay',
    data(){
        return{
			      tipsList:['包含6码、8码、10 码、2胆18拖', '包含7码、9码、11 码、2胆12拖','包含9码、10码、11 码、3胆10拖','含三种组合投注方式','含两种组合投注方式','含三种组合投注方式'],
            typeList:[
                {
                    typeName: '双色球12+3',
                    luckyNum: '赠1幸运币',
                    moneyNum: '1.18'
                },
                {
                    typeName: '双色球8+2',
                    luckyNum: '赠5幸运币',
                    moneyNum: '5.28'
                },
                {
                    typeName: '双色球6+1',
                    luckyNum: '赠10幸运币',
                    moneyNum: '10.68'
                },
                {
                    typeName: '大乐透10+4',
                    luckyNum: '赠1幸运币',
                    moneyNum: '1.18'
                },
                {
                    typeName: '大乐透8+3',
                    luckyNum: '赠5幸运币',
                    moneyNum: '5.28'
                },
                {
                    typeName: '大乐透5+2',
                    luckyNum: '赠10幸运币',
                    moneyNum: '10.68'
                }
            ],
            showPayType:false,
            isNoPay:false,
            citySelect:{
                coding:'32',
                city:'江苏'
            },
            newlist:itemList.data,
            lowList:[],
            heightList:[],
            cityList:[],//城市列表
            ListIndex: 0,
            contactKf: false,
            closeingStatus: false,//支付后弹层
            qrCodeList: [],
            qrCodeSrc: '',
            money: 0,
            byMoney: 0,
            djbyMoney: 0,
            isWxTips: false,
            userId: localStorage.getItem('jsjUserId'),
            orderId:'0',//订单号
            wxZfbTips:false,//微信中微信支付提示
            payType:'4',
            searchPayStatus:false,
            parPrompt:false,
            cityStatus:true,
            paramsObj:{},
            promptStatus:'',
            kqStatus:false,
            loadingStatus:false,
            selectPayStatus:false,//选择支付类型/ 余额支付/直接购买
            balancePayStatus:false,//余额支付成功后提示
            balanceNum:"--",//账户余额
            userName:localStorage.getItem('jsjUserName'),
            listLoading:true,
            lotteryList:{
				        "FC_KL8":null,
                "FC_SSQ":null,
                "TC_DLT":null,
                "FC_3D":null,
                "TC_PL3":null,
                "FC_K3":null,
                "TC_11X5":null

            },
            activityImg:[],
            choosetype: 'dq',
            istips: false,
            isKlb: false,
        }
    },
    filters:{
        /**
         *处理小数点
         */
        filterNum(num,type){
            if(type==1){
                if(num.indexOf('.')!==-1){
                    return num.split('.')[0]
                }else{
                    return num
                }
            }else{
                if(!Number(num)&&Number(num)!==0) return ''
                if(num.indexOf('.')!==-1){
                    return '.'+num.split('.')[1]
                }else{
                    return '.00'
                }
            }

        },
        /**
         *  FC_SSQ
            TC_DLT
            FC_3D
            TC_PL3
            /--------------高频
            FC_K3
            TC_11X5
         */
        typeName(name){
            let newName
            switch(name){
                case "FC_KL8":
                    newName = "快乐8";
                    break;
				        case "FC_SSQ":
                    newName = "双色球";
                    break;
                case "TC_DLT":
                    newName = "大乐透";
                    break;
                case "FC_3D":
                    newName = "3D";
                    break;
                case "TC_PL3":
                    newName = "排列3";
                    break;
                case "FC_K3":
                    newName = "快3";
                    break;
                case "TC_11X5":
                    newName = "11选5"

            }
            return newName
        }
    },
    methods: {
        byEvent(type){
            this.choosetype = type
        },
        toHisAnalysis1(lotteryName){
          this.$router.push({
              path:`/historyAnalysis1/${lotteryName}`
          })
        },
        activity(){
            let p = {
                transactionType: '10020809',
                sysType: 'U',
                data: {
                    type:"xhxy_hd_top_dsj"
                }
            };
            this.$post(p).then(res => {
                res = res.message.body
                this.activityImg = res.datas[0][Object.keys(res.datas[0])[0]].dataList[0];
            })
        },
        activityLink(){
            if(this.activityImg.url == []){
                return
            }
            if(this.activityImg.url.indexOf('http') >=0 || this.activityImg.url.indexOf('https') >=0){
                window.location.href = this.activityImg.url
            }else{
                this.$router.push({
                    path:'/'+this.activityImg.url
                })
            }
        },
        balancePayFn(){
            this.balancePayStatus = !this.balancePayStatus
            this.paramsObj = {}
            this.money = 0
            this.getLowList()
            //this.getHeightList(0)

        },
        closePayBox(){
            this.payType = ''
            this.showPayType = false

        },
        /**
         * 立即获取
         */
        paystatusfn(){
			      let sumMoney = this.choosetype=='dq' ? this.money.toFixed(2) : (this.money.toFixed(2)*1 + this.byMoney*1 - this.djbyMoney*1).toFixed(2)
            if(this.utils.isWxBrowser()){
                //判断在微信中打开
                this.wxZfbTips = true
                return
            }
            if(!this.userId){
                this.$router.push({
                    path:'/loginOrReg'
                })
                return
            }


            this.payType = '4'
			console.log(Number(sumMoney) + '-----' + sumMoney)
            if(!Number(sumMoney)){
                this.$toast('请选择购买商品')
                return
            }

            // this.showPayType = !this.showPayType
            if(Number(this.balanceNum)>=sumMoney){
                //调取余额支付
                this.payType = '0'
                this.rechargeFn()
            }else{
                /**
                 * 判断快3 AppStore版本
                 */
                if(this.utils.isK3()){
                    this.isNoPay = true
                    return
                }
                this.selectPayStatus = !this.selectPayStatus
            }
        },
        /**
         * 点击选择支付方式时的提示  小于20用微信  大于等于20用支付宝
         */
        // userSelectPay(s) {
        //     this.payType = s+''
        //     if(this.payType==='1'&&this.money<60){
        //         this.$toast('支付宝支付金额不能低于60')
        //         this.payType=''
        //     }
        // },
        /**
         * 倒计时
         */
        countdownFn(){
            let countDown = null
            let that = this
            if(countDown){
                clearInterval(countDown)
            }
            if(!that.heightList) return
                countDown = setInterval(()=>{
                for(let i = 0;i<that.heightList.length;i++){
                        let item = that.heightList[i]
                        if(item&&item.issueStatus=='1'){
                            let endTimestamp = (new Date(that.utils.fliterDate(item.endTime))).getTime()
                            let nowTime = (new Date()).getTime()
                            let timeDown = (endTimestamp - nowTime)/1000;
                            let minute,second,ms,timeDownText
                            if(timeDown>0){
                                minute = that.utils.formatNumber(Math.floor(timeDown/60%60))
                                second = that.utils.formatNumber(Math.floor(timeDown%60))
                                // ms = that.utils.formatNumber(Math.floor((endTimestamp - nowTime)%10))
                                timeDownText =  minute + ':' + second
                            }else{
                                timeDownText =  '00:00'
                                item.issueStatus = '2'
                                // setTimeout(()=>{
                                //     that.getHeightList(item.lotteryName)
                                // },3000)
                            }
                            that.heightList[i].countdownText = timeDownText
                            this.$forceUpdate()
                    }
                }

            },1000)
        },
        /**
         * 高频提示
         */
        promptFn(i){
            if(i=='FC_K3'){
                this.promptStatus = '1'
            }
            if(i=='TC_11X5'){
                this.promptStatus = '2'
            }
            this.contactKf = true

        },
        /**
         * 获取低频商品列表
         */
        getLowList(){
            let params= {
                transactionType: '11230101',
                sysType: 'WTG',
                data: {
                    userId: this.userId
                }
            }
            this.$post(params).then(res => {
                res = res.message.body
                if(res.resCode=="000000"){
                    this.processData(res.list,'0')
                    setTimeout(()=>{
                        this.listLoading = false
                    },1500)
                }else if(res.resCode === '3002'){
                    // this.closeingStatus = false
                    this.rnewLogin()
                    return
                }
            })
        },
        /**
         * 获取高频商品列表
         *
         *  i => 彩种类型
         *  0 => 所有高频彩种
         *  非0=> 具体高频彩种
         */
        // getHeightList(i){
        //     let params= {
        //         transactionType: '11230102',
        //         sysType: 'WTG',
        //         data: {
        //             userId: this.userId,
        //             provinceCode:this.citySelect.coding,
        //             lotteryName:i!==0?i:'',
        //             timeId:''
        //         }
        //     }
        //     this.$post(params).then(res => {
        //         res = res.message.body
        //         if(res.resCode=="000000"){
        //             this.processData(res.list,'1',i)
        //         }else if(res.resCode === '3002'){
        //             // this.closeingStatus = false
        //             this.rnewLogin()
        //             return
        //         }
        //     })
        // },

        toAnalysis (){
            this.$router.push({
                path:'/analysis'
            })
        },
        // 历史战绩
        toHisAnalysis(lotteryName){
            this.$router.push({
                path:`/historyAnalysis/${lotteryName}`
            })
        },
        /**
         * 选择商品  id 商品id
        *           type 0 低频  1 高频
        *           itemStatus/高频 1开期，0 停期  -1 无该彩种数据
        *           selectType 是否可购 0可购 1不可购
         */
        selectItem(id,type,itemStatus,selectType,errorMsg){
            if(selectType=='1'){
                 this.$toast(errorMsg)
                 return
            }
            //let data = this.newlist
            //let lowList = {}
            //let heightList = {}
            let paramsObj = this.paramsObj
            if(itemStatus!=='1'){
                this.$toast('方案已结束')
                return
            }
            this.isKlb = false
            this.istips = false
            let itemBox = type==0?this.lowList:this.heightList
            for(let k = 0; k < itemBox.length ;k++ ){
                let item = itemBox[k]
                let itemArr = []
                for(let j = 0;j<item.items.length;j++){
                    if(item.items[j].itemId==id){
                        item.items[j].selectStatus = !item.items[j].selectStatus
                        let num = this.money
                        if(item.lotteryName == 'FC_KL8' ){
                          this.djbyMoney =item.items[j].selectStatus ? this.djbyMoney*1 + item.items[j].price*1 : this.djbyMoney*1 - item.items[j].price*1
                          this.byMoney =item.items[j].selectStatus ? this.byMoney*1+ item.items[j].price *30*0.6 : this.byMoney*1-item.items[j].price *30*0.6
                        }
                        this.money = item.items[j].selectStatus ? ((this.money*1+item.items[j].price*1).toFixed(2))*1 : ((this.money*1-item.items[j].price*1).toFixed(2))*1
						        if(!item.items[j].selectStatus&&JSON.stringify(item.items).indexOf('true')==-1){
                            delete paramsObj[itemBox[k].lotteryName]
                        }

                    }
                    if(item.items[j].selectStatus){
                        if(type==0){
                            itemArr.push(item.items[j].itemId)
                            let lotteryName = itemBox[k].lotteryName
                            paramsObj[lotteryName] = {
                                type: '0',
                                items: itemArr
                            }

                        }else{
                            let itemObj = {}
                            let lotteryName = itemBox[k].lotteryName
                            itemObj[item.items[j].itemId] = item.items[j].schemeId
                            itemArr.push(itemObj)
                            paramsObj[lotteryName] = {
                                type: '1',
                                provinceCode: this.citySelect.coding,
                                items: itemArr
                            }
                        }

                  }
              }
            }
            if(Object.keys(paramsObj).indexOf('FC_KL8')!=-1){
              this.isKlb = true
            }
            if( (Object.keys(paramsObj).length>1) && (Object.keys(paramsObj).indexOf('FC_KL8')!=-1)){
              this.istips = true
            }
            this.$forceUpdate()
        },
        /**
         * 显示城市选择
         */
        cityShow(){
            this.cityStatus = !this.cityStatus
        },
        /**
         * 选择城市
         */
        selectCity(coding){
            this.cityStatus = false
            // if(coding==this.citySelect.coding) return
            for(let i in this.cityList){
                let item = this.cityList[i]
                item.status = false
                if(coding==item.coding){
                    item.status = true
                    this.citySelect = item
                    localStorage.setItem("citySelect",JSON.stringify(this.citySelect))
                    this.heightList = []
                    //this.getHeightList(0)
                    // this.getLowList()
                    // this.paramsObj = {}

                }
            }
            for(let i in this.paramsObj){
                if(this.paramsObj[i].type=="1"){
                    delete this.paramsObj[i]
                }
            }
        },
        closeCityStatus(e){
            if(e.target.className=='city_wraper'){
                this.cityStatus = false
            }
        },
        /**
         * 处理数据
         *  data : 彩种数据
         *  type : 高频/低频
         *  fun : 高频彩种类型
         *
         *   lotteryList:{
                FC_SSQ:null,
                TC_DLT:null,
                FC_3D:null,
                TC_PL3:null,
                FC_K3:null,
                TC_11X5:null
            }
         *
         */
        processData(data,type,fun){
            let itemBox = data
            for(let k = 0; k < itemBox.length ;k++ ){
                let item = itemBox[k]
                for(let j = 0;j<item.items.length;j++){
                    item.items[j].newSelectStatus = item.items[j].selectStatus
                    item.items[j].selectStatus = false;
                    // item.items[j].selectSta = item.items[j].selectStatus
                }
            }

            if(type=="0"){
                this.lowList = itemBox
                /**
                 * 重新排序低频列表顺序
                 */
                for(let i = 0;i<itemBox.length;i++){
                    if(itemBox[i].lotteryName==Object.keys(this.lotteryList)[i]){
                        this.lotteryList[Object.keys(this.lotteryList)[i]] = itemBox[i]
                    }
                }
            }else{
                /**
                 * 获取高频具体彩种
                 */
                if(fun!==0){
                    for(let k = 0; k < this.heightList.length ;k++ ){
                        if(this.heightList[k].lotteryName==fun){
                            this.heightList[k] = itemBox[0]
                            // this.lotteryList[Object.keys(fun)] = itemBox[0]
                        }
                    }
                    if(this.paramsObj[fun]){
                        delete this.paramsObj[fun]
                        if(this.showPayType){
                            this.kqStatus = true
                            this.showPayType = false
                            this.payType==''
                        }
                    }
                }else{
                    /**
                     * 首次获取全部高频
                     */
                    this.heightList = itemBox
                }
                /**
                 * 重新排序高频列表顺序
                 */
                for(let k in this.lotteryList){
                    for(let i in this.heightList){
                        if(k==this.heightList[i].lotteryName){
                            this.lotteryList[k] = this.heightList[i]
                        }
                    }
                }
                this.countdownFn()
                this.money = this.resetTotal(this.heightList)+this.resetTotal(this.lowList)
            }


        },
        sortList(){
           for(let y = 0;y<this.lotteryList.length;y++){
                console.log(this.lotteryList[y])

                // for(let i = 0;i<this.heightList.length;i++){
                //     if(this.heightList[i].lotteryName==Object.keys(this.lotteryList)[k]){
                //         this.lotteryList[Object.keys(this.lotteryList)[k]] = this.heightList[i]
                //     }
                // }

            }
        },
        /**
         * 计算所选总金额
         */
        resetTotal(arr){
            let num = 0
            for(let i = 0;i<arr.length;i++){
                let item = arr[i]
                for(let j = 0;j<item.items.length;j++){
                    if(item.items[j].selectStatus){
                        num = num+(item.items[j].price)*1
                    }
                }
            }
            return num
        },
        /**
         * 充值完成 回到幸运号码页
         */
        goBackFn(i){
            this.searchPayStatus = false
            if(i=='0') return
            if(!this.searchPayStatus){
                this.$router.push({
                    path:'/LuckyNumber'
                })
            }

        },
        /**
         * 点击支付完成  查询充值状态
         */
        payStatusFn(){
            let parameter = {
                transactionType: '11230202',
                sysType: 'WTG',
                data: {
                    orderId: this.orderId,
                    userId: this.userId
                }
            }
            this.$post(parameter).then(res => {
                res = res.message.body
                if(res.resCode === '000000'){
                    let message = ''
                    if(res.status === '0'){
                        message = '订单处理中...'
                        this.$toast(message)
                        return
                    }
                    if(res.status === '2'){
                        this.closeingStatus = false
                        this.searchPayStatus = true
                        this.$router.replace({
                            path:"/LuckyNumPay"
                        })
                    }
                    if(res.status === '8'){
                        message = '充值失败'
                        this.closeingStatus = false
                        Dialog.alert({
                            message: message
                        }).then(() => {

                        });
                    }
                }else if(res.resCode === '3002'){
                    this.closeingStatus = false
                    this.rnewLogin()
                    return
                }else{
                    this.$toast(res.message)
                }
            })
        },
        /**
         * 跨期弹层/确定按钮
         */
        kqFn(){
            this.kqStatus = false
        },
        /**
         * 点击支付按钮
         */
        confirmPayment() {
            this.showPayType = true
            this.loadingStatus = false
            if(this.payType==''){
                this.$toast('请选择支付方式')
                return
            }
            this.rechargeFn()
        },
        toZfbPay(){
            this.payType = '1'
            this.rechargeFn()
        },
        _utf8_encode(string) {
            string = string.replace(/\r\n/g, "\n");
            var utftext = "";
            for (var n = 0; n < string.length; n++) {
                var c = string.charCodeAt(n);
                if (c < 128) {
                    utftext += String.fromCharCode(c);
                } else if ((c > 127) && (c < 2048)) {
                    utftext += String.fromCharCode((c >> 6) | 192);
                    utftext += String.fromCharCode((c & 63) | 128);
                } else {
                    utftext += String.fromCharCode((c >> 12) | 224);
                    utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                    utftext += String.fromCharCode((c & 63) | 128);
                }
            }
            return utftext;
        },
        encode (input) {
            var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
            var output = "";
            var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
            var i = 0;
            input = this._utf8_encode(input);
            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);
                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;
                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }
                output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr
                    .charAt(enc4);
            }
            return output;
        },
        /**
         * 充值
         */
        rechargeFn(){
            this.showPayType = false
            this.loadingStatus = true
            let that = this
            let newObj = JSON.stringify(this.paramsObj)
            let parameter = {
                transactionType: '11230201',
                sysType: 'WTG',
                data: {
                    userId: this.userId,
                    totalMoney: (this.choosetype=='dq' ? this.money.toFixed(2) : this.money.toFixed(2)*1 + this.byMoney*1 - this.djbyMoney*1) + '',
                    payType: this.payType,
                    flag: '1',
					buyType: this.choosetype == 'dq' ? '0' : '1',  //0单期 1包月
                    items: this.encode(newObj)
                }
            }
            this.$post(parameter).then(res => {
                res = res.message.body
                if(res.resCode === '000000'){
                    this.orderId = res.orderId
                    if(this.payType=='0'){
                        this.loadingStatus = false
                        this.balanceNum = res.moneyBalance
                        localStorage.setItem('bean',res.moneyBalance)
                        this.balancePayStatus = !this.balancePayStatus
                    }else if(this.payType=='1'){
                        window.location.href = res.prepay_url
                        this.showPayType = false
                        setTimeout(()=>{
                            this.closeingStatus = true
                            this.loadingStatus = false
                        })
                    }else{
                        // localStorage.setItem('orderId',this.orderId)
                        localStorage.setItem('goBack',window.location.href)
                        //https://wx.tenpay.com/cgi-bin/mmpayweb-bin/checkmweb?prepay_id=wx0911363733166526b3590a7c1999917100&package=2755853533&Referer=http://jsj.shujujl.com&redirect_url=http://localhost:8080/LuckyNumPay/XYXH-20200609113637106-96665
                        window.location.href = `${res.mwebUrl}&Referer=http://jsj.shujujl.com&redirect_url=${window.location.origin}/LuckyNumPay/${this.orderId}`
                        this.showPayType = false
                    }
                }else if(res.resCode === '3002'){
                    this.rnewLogin()
                    return
                }else{
                    this.$toast(res.message)
                }
            })
        },
        // /**
        //  * 记录微信支付
        //  */
        // recordType(){
        //     let parameter = {
        //         transactionType: '10230419',
        //         sysType: 'WTG',
        //         data: {
        //             userId : this.userId,
        //             money : this.money+'',
        //             type : '1',
        //             flag: '1',
        //             lotteryName: this.ListIndex < 3 ? 'FC_SSQ':'TC_DLT'
        //         }
        //     }
        //     this.$post(parameter).then(res => {
        //     })
        // },
        /**
         * 获取微信支付二维码
         */
        getQrcode(){
            let parameter = {
                transactionType: '10020806',
                sysType: 'U',
                data: {
                    newFlag: '-1',
                    type : 'wtg_depo_random'
                }
            }
            this.$post(parameter).then(res => {
                let key = Object.keys(res.message.body.datas[0])
                res = res.message.body.datas[0][key].dataList
                res.forEach(v => {
                    if(v.title.indexOf('-') != '-1'){
                        v.title = v.title.split('-')[1]
                    }
                })
                this.qrCodeList = res
            })
        },
        /**
         * 关闭微信支付弹层  弹出支付提示框
         */
        payLayer(){
            this.isWxTips = false
            this.closeingStatus = true
        },
        /**
         * 关闭支付提示框
         */
        closePayLayer(){
            this.closeingStatus = false
            this.$router.replace({
                path:"/LuckyNumPay"
            })
        },
        /**
         * 弹出联系客服弹层
        */
        contactServer() {
            this.promptStatus = '0'
            this.contactKf = true

        },
		contactHelp() {
			this.promptStatus = '3'
            this.contactKf = true
		},
        /**
         * 关闭联系客服弹层
         */
        closeCallBox() {
            this.contactKf = false
        },
        /**
         * 重新登录
         */
        rnewLogin(){
            this.$dialog.confirm({
                message: '登录超时，请重新登录！',
                confirmButtonText: '去登录'
            }).then(() => {
                this.$router.push({
                    path:'/loginOrReg'
                })
            }).catch(() => {
            })
        },
        /**
         * 复制文字
         */
        wxCopy() {
            let _self = this
            this.$copyText('17710505950').then(function (e) {
                _self.$toast({
                    message: '复制成功'
                });
            }, function (e) {
                _self.$toast({
                    message: '复制失败，请手动复制输入'
                });
            });
        },
        /**
         * 复制链接
         */
        copyPrompt(){
            let that = this
            let Prompt = 'http://xz.xyxh888.cn'
            this.$copyText(Prompt).then(function (e) {
                that.$toast({
                    message: '复制成功'
                });
            }, function (e) {
                that.$toast({
                    message: '复制失败，请手动复制输入'
                });
            });
        },

        goBack(){
            if(this.orderId){
                this.$router.push({path:'/'})
                return false
            }else{
                if (window.history.length <= 1) {
                    this.$router.push({path:'/'})
                    return false
                } else {
                    this.$router.go(-1)
                }
            }

        },
        trans_src(src) {
            var arr = src.split("%7C")[1];
            return `1${arr.substr(1,1)}${arr.substr(3,3)}0${arr.substr(6,4)}`;
        },
         /**
         * 查询用户抢多多信息
         */
        queryUserInfo() {
            let p = {
                transactionType: '10230406',
                sysType: 'WTG',
                data: {
                    userId: localStorage.getItem('jsjUserId'),
                    oprSys : "Z"
                }
            }
            this.$post(p).then(res => {
                res = res.message.body
                if(res.resCode === '000000'){
                    this.balanceNum = res.moneyBalance
                    // localStorage.setItem('bean',this.bean)
                }else if(res.resCode === '3002'){
                    localStorage.removeItem('jsjUserId')
                    localStorage.removeItem('JSESSIONID')
                    localStorage.removeItem('hrefStr')
                    this.rnewLogin()
                }else{
                    this.$toast(res.message)
                }
            })
        },
    },
    mounted() {

        this.cityList = cityList.cityList
        let citySelect = JSON.parse(localStorage.getItem('citySelect'))
        if(citySelect){
            this.cityStatus = false
        }
        for(let i in cityList.cityList){
            let item = cityList.cityList[i]
            item.status = false
            if(citySelect){
                if(citySelect.coding==item.coding){
                    item.status = true
                    this.citySelect = item
                }
            }else{
                if(item.coding=='32'){
                    item.status = true
                    this.citySelect = item
                }
            }
        }
        this.activity();
        //获取商品列表
        this.getLowList()
        //this.getHeightList(0)
        if(localStorage.getItem('jsjUserId')){
            this.queryUserInfo()
        }
        // let fromSrc = this.utils.request_url()

        if(localStorage.getItem('channelSrc')){
            sessionStorage.setItem("fromSrc",this.trans_src(localStorage.getItem('channelSrc')+'%7C6002021000'))
        }

        this.orderId = this.$route.params.orderId
        if(this.orderId !== undefined && this.orderId != null){
            this.closeingStatus = true // 展示微信弹窗
        }

    },
    destroyed(){
        // if(localStorage.getItem('orderId')){
        //     localStorage.removeItem('orderId')
        // }
    }

}
</script>
<style scoped>
 	.sj{
		font-family: PingFang SC;
		font-weight: 500;
		font-size: 20px;
		color: #EA3846;
		letter-spacing: -1;
		display: inline-block;
	}
    .type_list .list_item_jx{
        /* display: inline-block; */
        /* float: left; */
        /* width: 220px; */
        /* width: 100%; */
        height: 116px;
        border: 2px solid #d4d4d4;
        border-radius:12px;
        text-align: center;
        /* padding-top: 25px; */
        margin: 0 25px 23px 20px;
        position: relative;
    }
    .top_type{
        background-color: #ffffff;
        /* padding: 0 20px 13px; */
        border-radius:15px;
        border-top-right-radius: 0;
        border-top-left-radius: 0;
    }
    .ps_info_box{
        background-color: #ffffff;
        overflow: hidden;
    }
    .ps_info{
        /* padding:0 20px; */
        text-align: left;
        text-indent: 23px;
        margin:13px 0 15px;
        font-size: 24px;
        color: #ef9a3b;
    }
    .ps_info2{
        height: 54px;
        background:rgba(255,192,22,0.3);
        line-height: 54px;
        color: #FF173E;
        font-size: 26px;
        text-indent: 23px;
    }


/* ---------------------------------------------------------------------- */
  .wrapper{
    width: 100%;
    margin-bottom: 115px;
  }
  .wrapper1{
    margin-bottom: 200px;
  }
	.bot_con{
		width: 100%;
		position: fixed;
        left: 0;
        bottom: 0;
		background: #FBF9FE;
		box-shadow: 0px -4px 10px 0px rgba(0,0,0,0.1);
	}
    .pay_wrapper{
        width: 100%;
        height: 100px;
        display: flex;
        flex-direction: row;
    }
	.pay_top{
		width: 100%;
		background-color: #fff;
		padding: 13px 0 20px 0;
	}
	.pay_top img{
		width: 24px;
		height: 24px;
		margin-right: 5px;
		vertical-align: middle;
	}
	.pay_top .gmfs{
		padding-left: 35px;
		font-size: 24px;
		color: #3E1D1C;
		margin-top: 10px;
	}
	.lz{
		position: absolute;
		right: -85px;
		top: -5px;
		width: 78px!important;
		height: 34px!important;
	}
	.pay_top .gmfs span{
		color: #666666;
	}
	.pay_top .gmfs span:nth-child(1){
	    margin-right: 20px;
	}
	.pay_top .gmfs span:nth-child(2){
	    position: relative;
	}
	.pay_top .gmfs span:last-child{
		float: right;
		margin-right: 30px;
	}
    .total_amount{
        /* width: 454px; */
        width: 60%;
        height: 100px;
        background: #441B1B;

    }
    .total_amount p:nth-child(1){
        width: 100%;
        height: 100px;
        line-height: 100px;
        color: #fff;
        font-size: 28px;
        text-indent: 39px;

    }
    .total_amount p:nth-child(1) span{
        font-size: 38px;
    }
    .total_amount p:nth-child(2){
        font-size: 22px;
        text-indent: 39px;
        color: #feda15;
    }
    .now_get{
        /* width: 296px; */
        width: 40%;
        height: 100px;
        line-height: 100px;
        background: #FFC016;
        color: #CC0006;
        font-size: 36px;
        text-align: center;

    }
    .city_wraper{
        width: 100%;
        position: fixed;
        left: 0;
        top: 100px;
        right: 0;
        bottom: 0;
        z-index: 1;
        background: rgba(0, 0, 0, 0.7);
    }
    .city_wraper p{
        height: 20px;
        background: url('../../assets/img/base/img_triangle_top@2x.png') 95px 2px no-repeat;
        background-size: 46px 18px;
    }
    .city_box{
        width: 585px;
        /* height: 566px; */
        background:rgba(255,255,255,1);
        border-radius:20px;
        margin: 0 auto;
        padding: 43px 52.5px;
        overflow: hidden;
    }
    .city_box li{
        width: 145px;
        height: 65px;
        line-height: 65px;
        text-align: center;
        color: #555555;
        float: left;
    }
    .city_box .select_city{
        color: #671D00;
        background:rgba(255,192,22,1);
        border-radius:10px;

    }
    .item_title{
        width: 100%;
        height: 90px;
        overflow: hidden;
        display: flex;
        /* flex-direction: row; */
    }
    .item_title>span{
        float: left;
        width: 179px;
        height: 90px;
        line-height: 90px;
        text-indent: -20px;
        text-align: center;
        /* float: left; */
        color: #FFFFFF;
        font-weight: Bold;
        font-family:PingFang SC;
        font-size:34px;
        background: url('../../assets/img/luckyNum/caizhong_bg@2x.png') -10px 0 no-repeat;
        background-size: 179px 90px;
    }
    .item_title>p{
        float: left;
        height: 90px;
        line-height: 90px;
        font-size: 22px;
        color: #555555;
        padding-left: 20px;
        /* float: right; */
    }
    .item_title .item_title_p{
        /* float: right; */
        margin-right: 25px;
        font-size: 26px;
        color: #34a0c9;
        flex: 1;
        text-align: right;
    }
    .item_title .item_title_text{
        margin-right: 25px;
        font-size: 26px;
        color: #304FFF;
        flex: 1;
        text-align: right;
    }
    .item_title>p>span{
        color: #FF173E;
        font-size: 30px;
        font-weight: bold;
    }
    .item_title>i{
        width: 52px;
        height: 52px;
        float: right;
        margin: 19px 23px 0 0 ;
        background: url('../../assets/img/luckyMoney/btn_info@2x.png') 0 0 no-repeat;
        background-size: 52px;
    }

    .type_title{
        display: flex;
        justify-content: space-between;
        /* margin-bottom: 30px; */
        padding: 0 20px;
    }
    .type_title .type_select{
        color: #333333;
        font-size: 30px;
		margin-top: 20px;
    }
    .type_title .check_num{
        color: #4B8ADF;
        font-size: 24px;
    }
    .type_list{
        font-size: 0;
        /* overflow: hidden; */
        /* padding-left: 20px; */
    }
    .type_list:after{
        content: "\200B";
        display: block;
        height: 0;
        clear: both;
    }
    .type_list .list_item{
        /* display: inline-block; */
        float: left;
        /* width: 220px; */
        width: 29%;
        height: 116px;
        border: 2px solid #d4d4d4;
        border-radius:12px;
        text-align: center;
        /* padding-top: 25px; */
        margin: 0 0 23px 20px;
        position: relative;
    }
    .list_item_img{
        width: 58px;
        height: 26px;
        line-height: 26px;
        position: absolute;
        top: 0;
        right: -1px;
        background: url('../../assets/img/luckyNum/iconRight.png') left bottom no-repeat;
        background-size: 58px 26px;
        border-radius: 0 12px 0 0;
        font-size: 18px;
        color: #441b1b;
    }
	.list_item{
		margin-bottom: 10px;
	}
    .type_list .select{
		    color: #FF173E;
        border: 2px solid rgba(255,23,62,1);
        background: url('../../assets/img/luckyNum/right_left@2x.png') left bottom no-repeat;
        background-size: 46px 46px;

    }
     .select1{
        /* color: #FF173E;
        border: 2px solid rgba(255,23,62,1); */
        background: url('../../assets/img/home/kl8_red.png') left bottom no-repeat !important;
        background-size: 46px 46px;
    }
	.mar_line1{
        width: 219px!important;
        height: 137px!important;
        background: url('../../assets/img/home/pink.png')  no-repeat;
        background-size: 100% 100%!important;
		    border: none!important;
	}
	.select2{
        width: 219px!important;
        height: 110px!important;
        background: url('../../assets/img/home/kl8_red.png') left bottom no-repeat;
        background-size: 100% 100%!important;
		    border: none!important;
	}
    .type_list .type_name{
        font-size: 28px;
        color: #333333;
        font-weight:800;
        margin: 5px auto 0;
        /* white-space:nowrap; */
        height: 70px;
        /* line-height: 75px; */
        display: flex;
        flex-direction: column;
        justify-content: center;
        -webkit-box-pack: center;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        /* overflow:hidden;
        text-overflow:ellipsis; */
    }
	.mar_line1 .type_name1{
		height: 70px!important;

	}
	.type_list .type_name1{
		display: flex;
		height: 50px;
		align-items: flex-end;
		justify-content: center;
		flex-direction: row;
		white-space: nowrap;
		font-size: 24px;

	}

    .type_list .select_item{
        color:#FF173E !important;
    }
	.noSelect_item1{
		width: 220.75px!important;
		height: 137px!important;
		background: url('../../assets/img/home/kl8_gray.png')  no-repeat!important;
        background-size: 100% 100%!important;
		border: none!important;
	}
    .type_list .noSelect_item{
        color:#B0B0B0 !important;
    }
	.no_sj{
		color:#B0B0B0 !important;
	}
    .type_list .lucky_num{
        font-size: 24px;
        color: #555;
        font-weight:500;
        /* margin: 5px 0 10px; */
    }
    .type_list .money_num{
        font-size: 24px;
        color: #555;
        font-weight:500;
    }
	.money_num1{
		font-family: PingFang SC;
		font-weight: 500;
		font-size: 20px;
		color: #555555;
	}
    .type_list .dylz{
        padding: 0 0 0 49px;
    }
    .type_list .new_luckynum{
        position: absolute;
        width: 65px;
        height: 43px;
        top: -13px;
        right: 6px;
        background: url('../../assets/img/luckyNum/new.png') center center no-repeat;
        background-size: 55px 33px;

    }
    .type_list .list_AIitem{
        /* display: inline-block; */
        float: left;
        /* width: 220px; */
        width: 29%;
        height: 132px;
        text-align: center;
        /* padding-top: 25px; */
        margin: 0 0 23px 20px;
        position: relative;
        border: 2px solid transparent;
        background: url('../../assets/img/luckyNum/ai_noselect.png') center center no-repeat;
        background-size: 100%;
        padding-top: 5px;

    }
    .type_list .list_AIitem .type_name{
        font-size: 28px;
        color: #333333;
        font-weight:800;
        /* white-space:nowrap; */
        height: 70px;
        line-height: 70px;
        display: -webkit-box;
        /* flex-direction: column;
        justify-content: center; */
        margin-top: 10px;
        /* overflow:hidden;
        text-overflow:ellipsis; */
    }
    .type_list .AISelect{
        background: url('../../assets/img/luckyNum/ai_select.png') center center no-repeat;
        background-size: 100%;
    }
    .type_list .AI_gray{
        background: url('../../assets/img/luckyNum/ai_gray.png') center center no-repeat;
        background-size: 100%;
    }

    .type_list .list_AIitem2{
        /* display: inline-block; */
        /* float: left; */
        /* width: 220px; */
        width: 96%;
        height: 157px;
        text-align: center;
        /* padding-top: 25px; */
        margin: 0 0 13px 10px;
        position: relative;
        border: 2px solid transparent;
        background: url('../../assets/img/luckyNum/ai_noselect2.png') center center no-repeat;
        background-size: 100%;
        padding-top: 5px;

    }
    .type_list .list_AIitem2 .type_name{
        font-size: 28px;
        color: #333333;
        font-weight:800;
        /* white-space:nowrap; */
        height: 70px;
        line-height: 70px;
        display: -webkit-box;
        /* flex-direction: column;
        justify-content: center; */
        margin-top: 17px;
        /* overflow:hidden;
        text-overflow:ellipsis; */
    }
    .type_list .AISelect2{
        background: url('../../assets/img/luckyNum/ai_select2.png') center center no-repeat;
        background-size: 100%;
    }
    .type_list .AI_gray2{
        background: url('../../assets/img/luckyNum/ai_gray2.png') center center no-repeat;
        background-size: 100%;
    }

    .type_list .list_AIitem3{
        /* display: inline-block; */
        /* float: left; */
        /* width: 220px; */
        width: 96%;
        height: 157px;
        text-align: center;
        /* padding-top: 25px; */
        margin: 0 0 13px 10px;
        position: relative;
        border: 2px solid transparent;
        background: url('../../assets/img/luckyNum/AI_big_dlt.png') center center no-repeat;
        background-size: 100%;
        padding-top: 5px;

    }
    .type_list .list_AIitem3 .type_name{
        font-size: 28px;
        color: #333333;
        font-weight:800;
        /* white-space:nowrap; */
        height: 70px;
        line-height: 70px;
        display: -webkit-box;
        /* flex-direction: column;
        justify-content: center; */
        margin-top: 17px;
        /* overflow:hidden;
        text-overflow:ellipsis; */
    }
    .type_list .AISelect3{
        background: url('../../assets/img/luckyNum/ai_select3.png') center center no-repeat;
        background-size: 100%;
    }
    .type_list .AI_gray3{
        background: url('../../assets/img/luckyNum/ai_gray3.png') center center no-repeat;
        background-size: 100%;
    }

    .type_list .list_AIitem4{
        /* display: inline-block; */
        /* float: left; */
        /* width: 220px; */
        width: 96%;
        height: 157px;
        text-align: center;
        /* padding-top: 25px; */
        margin: 0 0 13px 10px;
        position: relative;
        border: 2px solid transparent;
        background: url('../../assets/img/luckyNum/AI_big_ssq.png') center center no-repeat;
        background-size: 100%;
        padding-top: 5px;

    }
    .type_list .list_AIitem4 .type_name{
        font-size: 28px;
        color: #333333;
        font-weight:800;
        /* white-space:nowrap; */
        height: 70px;
        line-height: 70px;
        display: -webkit-box;
        /* flex-direction: column;
        justify-content: center; */
        margin-top: 17px;
        /* overflow:hidden;
        text-overflow:ellipsis; */
    }
    .type_list .AISelect4{
        background: url('../../assets/img/luckyNum/ai_select3.png') center center no-repeat;
        background-size: 100%;
    }
    .type_list .AI_gray4{
        background: url('../../assets/img/luckyNum/ai_gray3.png') center center no-repeat;
        background-size: 100%;
    }

    .payWraper{
        width: 95%;
        border-radius: 20px;
    }

    .pay_box{
        margin-top: 10px;
        width: 90%;
        /* height: 241px; */
        background:rgba(255,255,255,1);
        border-radius: 15px;
        padding: 0 5% 50px;

    }
	.pay_title1{
		width: 750px;
		height: 40px;
		background: #FBF9FE;
		box-shadow: 0px -4px 10px 0px rgba(0,0,0,0.1);
	}
	.pay_tips{
		font-family: PingFang SC;
		font-weight: 500;
		font-size: 20px;
		color: #EC2025;
		text-align: center;
	}
    .pay_box .pay_title {
        font-size: 30px;
        color: #333333;
        padding: 29px 0 0 0;
        margin-bottom: 27px;
    }
    .pay_box .pay_item{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        height:120px;
        background:rgba(255,255,255,1);
        border: 2px solid rgba(255,23,62,1);
        border-radius: 12px;
        background: url('../../assets/img/luckyNum/right_right@2x.png') top right no-repeat;
        background-size: 58px 59px;
        margin-bottom: 20px;
    }
    .pay_item .pay_logo{
        width: 68px;
        height: 68px;
        background: url('../../assets/img/luckyNum/weixinzhifu@2x.png') no-repeat;
        background-size: 100% 100%;
        margin-left: 34px;
        margin-right: 23px;
    }
    .pay_item .zfbpay_logo{
        background: url('../../assets/img/luckyNum/weixinzhifu@2x.png') no-repeat;
    }
    .pay_card{
        width: 80%;
    }
    .pay_card .pay_info{
        font-size: 22px;
        color: #999999;
    }
    .pay_card .pay_name{
        font-size: 32px;
        color: #1D1D1D;
        background: url('../../assets/img/pay/biaoqianjishi@2x.png') 150px center no-repeat;
        background-size: 207px 33px;
    }
    .affirm_info{
        font-size: 24px;
        color: #959595;
        text-align: center;
        margin-top: 40px;
    }
    .affirm_pay{
        width:100%;
        height:117px;
        margin-top: 30px;
    }
    .affirm_pay .pay_btn{
        width: 78%;
        height:89px;
        line-height: 89px;
        background:#FFC016;
        border-radius:9px;
        color: #CC0006;
        font-size: 40px;
        text-align: center;
        margin: 14px auto 0;
    }

    .header{
        width: 100%;
        position: fixed;
        top: 0px;
        left: 0;
        z-index: 999;
    }
    .city_btn{
        position: absolute;
        top: 24px;
        left: 48px;
        width: 141px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        border: 2px solid #671D00;
        border-radius:10px;
        z-index: 1;
        font-size: 30px;
    }
    .city_btn span{
        font-size: 16px
    }
    .van-nav-bar{
        height: 100px;
        line-height: 100px;
        z-index: 1;
        background-color: #FFC016;
        color: #000000;
    }
    .van-nav-bar__title{
        font-size: 32px;
        color: #671D00;
    }
    .van-nav-bar .van-icon {
        font-size: 40px;
        color: #671D00;
        cursor: pointer;
        vertical-align: middle;
    }
    .van-nav-bar__arrow {
        min-width: 1em;
    }
    .van-icon {
        position: relative;
        display: inline-block;
        font: normal normal normal 14px/1 "vant-icon";
        text-rendering: auto;
        -webkit-font-smoothing: antialiased;
    }
    .van-icon-arrow-left:before {
        content: "\F008";
    }
    .van-icon::before {
        display: inline-block;
    }
    .bar__arrow{
        width: 17px;
        height: 33px;
    }
    .contact{
        height: 150px;
        display: flex;
        align-items: center;
    }
    .contact .contact_bg{
        width: 40px;
        height: 40px;
        background: url('../../assets/img/luckyNum/contact_logo.png') no-repeat;
        background-size: 100% 100%;
        display: inline-block;
    }
    .contact .contact_text{
        font-size: 28px;
        color: #4E0200;
        margin-left: 10px;
    }
    /* 联系客服end */
    .bg_box{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1800;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.8)
    }
    .bg_box .call_box{
        width:83%;
        height:460px;
        background:rgba(243,243,243,1);
        border-radius:20px;
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }
    .bg_box .call_box1{
        width:83%;
        height:360px;
        background:rgba(243,243,243,1);
        border-radius:20px;
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }
    /* .call_box{
        position: relative;
    } */
    .close_btn{
        position: absolute;
        top: 32px;
        right: 32px;
        width: 31px;
        height: 31px;
        background: url('../../assets/img/luckyNum/close_pop@2x.png') no-repeat;
        background-size: 100% 100%;
    }
    .call_text{
        font-size: 28px;
        color: #333333;
        margin-left: 71px;
        margin-top: 20px;
    }
    .describe{
        font-size: 28px;
        color: #333333;
        margin: 40px 30px 0 71px;
    }
    .describe1{
        font-size: 28px;
        color: #333333;
        margin: 40px 30px 0 40px;
    }
    .wx_box{
        margin-top: 40px;
        margin-bottom: 40px;
    }
    .c_item{
        font-size: 30px;
        color: #2468FF;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .c_item img{
        width: 40px;
        height: 40px;
        margin-left: 95px;
        margin-right: 16px;
        font-size: 30px;
        color: #2468FF;
    }
    /* 联系客服end */
    .suc_item, .suc_item img{
        margin-left: 0;
    }
    .suc_box .wx_box{
        margin-top: 30px;
        margin-bottom: 30px;
    }
    .qrCode_con{
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.7);
        z-index: 1;
    }
    .qrCode_con p{
        width: 62px;
        height: 62px;
        margin: 150px auto 30px;
        background: url('../../assets/img/pay/close.png') 0 0 no-repeat;
        background-size: 62px;
    }
    .qrCode_con img{
        width: 75%;
        display: block;
        margin: 0 auto
    }
    .suc_box{
        width: 67%;
        height: 510px;
        background:rgba(243,243,243,1);
        border-radius:20px;
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        padding: 0 8%;
    }
    .suc_box .suc_info{
        margin-top: 50px;
        font-size: 32px;
        color: #000000;
    }
    .suc_box .suc_fack{
        margin-top: 20px;
        font-size: 30px;
        color: #000000;
    }
    .suc_box .suc_wx, .suc_box .suc_phone{
        margin-top: 20px;
        font-size: 28px;
        color: #000000;
    }
    .pay_btn_box{
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        line-height: 80px;
        margin-top: 40px;
    }
    .pay_btn_box div{
        width:240px;
        height:80px;
        border-radius:20px;
        font-size: 36px;
    }
    .pay_btn_box .pay_again{
        background:rgba(255,255,255,1);
        border: 2px solid #d4d4d4;
        margin-right: 48px;
        color: #333333;
    }
    .pay_btn_box .pay_suc{
        background:#FFC016;
        border: 2px solid #FFC016;
        color: #CC0006;
    }
    .zfb_tips{
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.7) url('../../assets/img/pay/wx_pay_layer.png') 0 0 no-repeat;
        background-size: 100%;
        z-index: 1000;
        text-align: center;
        overflow: hidden;
    }


    .first_tc_box{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.7)
    }
    .first_tc_box .f_layer{
        position: absolute;
        width:70%;
        height:auto;
        background:rgba(243,243,243,1);
        border-radius:20px;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        padding: 0 6% 3%;
        font-size: 30px;
        color: #333333;
        text-align: center
    }
    .f_layer .f_layer_text1{
        margin: 30px 0 20px;
    }
    .f_layer .pay_before1{
        margin: 30px 0 20px;
        padding-top: 50px;
        font-size: 28px;
        text-align: left;

    }
    .f_layer .pay_before2{
        color: #4B8ADF;
        font-size: 28px;
        padding: 30px 0 25px;
        text-align: left;

    }
    .f_layer .f_layer_text3{
        font-size: 30px;
        margin: 30px 0 20px;
    }
    .f_layer .f_layer_text4{
        font-size: 26px;
    }
    .f_layer_text5{
        font-size: 30px;
        margin: 30px 0 20px;
        color:red;
    }
    .f_layer .f_layer_text4 span:nth-child(1){
        font-size: 30px;
        color: blue;
    }
    .f_layer .f_layer_text4 span:nth-child(2){
        font-size: 26px;
    }
    .f_layer .f_btn{
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 50px 0 20px;
    }
    .f_layer .f_btn .item_btn{
        width: 240px;
        height: 80px;
        border-radius:20px;
        text-align: center;
        line-height: 80px;
        font-size: 30px;
        color: #333333;
    }
    .f_layer .f_btn .cancel{
        background:rgba(255,255,255,1);
        margin-right: 3%;
    }
    .f_layer .f_btn .confirm{
        background:rgba(255,192,22,1);
        color: #CC0006;
        margin-left: 3%;
    }
    .payPrompt{
        margin: 80px 0 20px;
        padding: 10px 20px 2px;
        font-size: 30px;
        color: #333333;
        line-height: 50px;
        background: #fff;
        border-radius:15px;
    }
    .payPrompt p:nth-child(3){
        width: 240px;
        line-height: 70px;
        text-align: center;
        border-radius: 10px;
        margin: 30px auto;
        font-size:30px;
        background: #fff;
        border:2px solid #ccc;
    }


    .itempay_box{
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border:2px solid #d4d4d4;
        border-radius:12px;
        height: 120px;
        background: #fff;
    }
    .select_pay{
        border:2px solid #FF173E;
    }
    .ali_pay_box{
        background: url('../../assets/img/pay/biaoqian@2x.png') 304px 28px no-repeat;
        background-size: 207px 33px;
        margin-bottom: 20px;
    }
    .wx_pay_box{
        background: #fff url('../../assets/img/pay/biaoqianjishi@2x.png') 275px 28px no-repeat;
        background-size: 207px 33px;
    }
    .pay_logo{
        width: 78px;
        height: 78px;
        background: url('../../assets/img/pay/zhifubao@2x.png') no-repeat;
        background-size: 100% 100%;
        margin-left: 33px;
        margin-right: 20px;
    }
    .wx_pay_box .pay_logo{
        width: 82px;
        height: 69px;
        background: url('../../assets/img/pay/weixinzhifu@2x.png') no-repeat;
        background-size: 100% 100%;
        margin-left: 33px;
        margin-right: 20px;
    }
    .pay_text{
        width: 80%;
        font-size: 32px;
        color: #1D1D1D;
    }
    .pay_text .type_info{
        font-size: 22px;
        color: #999999;
    }
    .select_pay .sub_script{
        position: absolute;
        right: -1px;
        top: -1px;
        width: 58px;
        height: 59px;
        background: url('../../assets/img/pay/select_red@2x.png') no-repeat;
        background-size: 100% 100%;
    }
    .user_info{
        width: 100%;
        /* height: 172px; */
        padding-top: 100px;
        background: #FFC016;
        overflow: hidden;
    }

    .info_box{
        float: left;
        width: 45%;
        padding-top: 18px;
    }
    .info_box .info_name1{
        color: #671D00;
        font-size: 28px;
        font-weight: bold;
        display: block;
        padding-left:30px;
    }
    .info_box .info_name2{
        padding-top: 5px;
        font-size: 28px;
        color: #671D00;
        display: block;
        padding-left:30px;
        color: #671D00;
        font-weight: bold;
    }
    .info_box .info_name2 .balance_num1{
        font-size: 39px;
        color: #FF173E;
    }
    .info_box .info_name2 .balance_num2{
        font-size: 28px;
        color: #FF173E;
    }
    .info_box .info_name2 .yuan{
        font-size: 28px;
        color: #671D00;
    }




    .info_box1{
        float: left;
        width: 52%;
        padding-top: 10px;
    }
    .info_box1 span{
        display: block;
        padding-left:40px;
    }
    .info_box1 span:nth-child(1){
        color: #671D00;
        font-size: 28px;
        font-weight: bold;
    }
    .info_box1 span:nth-child(2){
        padding-top: 5px;
        font-size: 28px;
        color: #671D00;
    }
    .info_btn{
        margin:20px 0 0 0px;
        width: 55%;
        height: 105px;
        overflow: hidden;
    }
    .info_btn li{
        float: left;
        height: 82px;
        color: #743001;
        font-size: 26px;
        line-height: 82px;
        text-align: center;
    }
    .info_btn li:nth-child(1){
        margin: 0 10px;
        width: 154px;
        background: url('../../assets/img/luckyMoney/btn_bag1.png') no-repeat;
        background-size: 154px 82px;
    }
    .info_btn li:nth-child(2){
        color: #FF173E;
        width: 216px;
        background: url('../../assets/img/luckyMoney/btn_bag2.png') no-repeat;
        background-size: 216px 82px;
    }

    .info_btn1{
        margin:10px 0 0 0px;
        width: 48%;
        height: 105px;
        overflow: hidden;
    }
    .info_btn1 li{
        float: left;
        height: 82px;
        color: #743001;
        font-size: 26px;
        line-height: 82px;
        text-align: center;
    }
    .info_btn1 li:nth-child(1){
        margin: 0 10px;
        width: 154px;
        background: url('../../assets/img/luckyMoney/btn_bag1.png') no-repeat;
        background-size: 154px 82px;
    }
    .info_btn1 li:nth-child(2){
        color: #FF173E;
        width: 154px;
        background: url('../../assets/img/luckyMoney/btn_bag1.png') no-repeat;
        background-size: 154px 82px;
    }
    .list_loading{
        width: 150px;
        height: 150px;
        background: rgba(0,0,0,0.5);
        border-radius: 10px;
        position: fixed;
        left: 50%;
        top: 50%;
        margin: -75px 0 0 -75px;
    }
    .balance_box{
        display: inline-table;
        position: relative;
    }
    .bottom_line{
        /* text-decoration: underline; */
        width: 100%;
        height: 2px;
        background: #FF173E;
        position: absolute;
        bottom: 3px;
        left: 0;

    }

    .activity{
        width: 100%;
        height: 120px;
        background: #fff url('../../assets/img/luckyNum/fsc.png') 0 15px no-repeat;
        background-size: 100%;
    }
    .text_color1{
        color: #3EB771;
    }
    .text_color2{
        color: #1722FF;
    }
    .text_color3{
        color: #FF173E;
    }
    .activityImgBox{
        padding-top:10px;
    }
	.part{
		width: 100%;
		height: 160px;
		background: #FFFFFF;
		color: #333333;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 84px;
		margin-top: 100px;
		box-sizing: border-box;
		font-weight: 500;
		font-size: 26px;
	}
	.part div{
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-direction: column;
	}
	.part img{
		width: 104px;
		height: 104px;
	}
	.line{
		width: 750px;
		height: 20px;
		background: #FBF9FE;
	}
	.select_type{
		color: #333333;
	}
	.call_text1{
		margin: 50px auto 10px;
		text-align: center;
	}
	.konw_btn{
		width: 150px;
		height: 60px;
		background: #FFC016;
		color: #FFFFFF;
		font-size: 30px;
		text-align: center;
		line-height: 60px;
		margin: 60px auto 0;
	}
	.describe2{
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// src/views/LuckyNumPay/LuckyNumPay.vue